export default {
  title: 'Tarifas',
  subtitle: 'Anulación de tarifa de servicio por restaurante para {{company}}.',
  card_title: 'Tarifa de servicio',
  banner: {
    default_summary: 'Valor predeterminado del socio: {{percentage}}% · mín. {{min}} · máx. {{max}}.',
    override_hint: 'Anule a continuación para establecer una tarifa diferente para este restaurante.',
    suggested_summary: 'Valores iniciales sugeridos: {{percentage}}% · mín. {{min}} · máx. {{max}}.',
    suggested_hint: 'Ajústalos abajo y guarda para cobrar una tarifa de servicio en este restaurante.',
    own_fee_hint: 'Este restaurante cobra su propia tarifa, configurada abajo.',
    saved_summary: 'Tus últimos valores guardados: {{percentage}}% · mín. {{min}} · máx. {{max}}.',
    saved_hint:
      'La tarifa de servicio está desactivada. Guarda estos valores, o cámbialos antes, para volver a activarla.',
  },
  form: {
    recommended: 'Recomendado: {{value}}',
    percentage: {
      label: 'Porcentaje de tarifa de servicio',
      tooltip: 'Porcentaje del valor del pedido cobrado al cliente como tarifa de servicio.',
    },
    min_amount: {
      label: 'Importe mínimo de tarifa de servicio',
      tooltip: 'Las tarifas calculadas por debajo de este importe se redondean hacia arriba.',
    },
    max_amount: {
      label: 'Importe máximo de tarifa de servicio',
      tooltip: 'La tarifa de servicio nunca supera este importe, independientemente del valor del pedido.',
    },
  },
  limits:
    'Debe mantenerse dentro de los límites de FoodAmigos: máx. {{max_percentage}}% / {{max_amount}}, mínimo al menos {{min_amount}}.',
  not_charged_notice:
    'Actualmente no se cobra ninguna tarifa de servicio en este restaurante. Guarda una tarifa abajo para activarla.',
  zero_percentage_warning:
    'Un porcentaje del 0% no desactiva la tarifa de servicio: las tarifas calculadas por debajo del importe mínimo se redondean hacia arriba, por lo que cada pedido sigue cobrando al menos el mínimo.',
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
    reset_to_default: 'Restablecer valor predeterminado del socio',
    turn_off: 'Desactivar tarifa de servicio',
  },
  toasts: {
    load_error: 'No se pudieron cargar los ajustes de tarifa de servicio.',
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados',
    reset_to_default: 'Anulación eliminada: se aplica el valor predeterminado del socio.',
    reset_to_default_skipped: 'Anulación eliminada: no se cobrará ningún cargo por servicio hasta que guardes uno.',
    turned_off: 'Tarifa de servicio desactivada. Tus valores se conservan para cuando la vuelvas a activar.',
  },
};
